import { SaleFormInput } from '@src/core/buyerApiClient';
import { normalizeFormInputValue } from '@src/domains/orders/core/form-inputs/normalizeFormInputValue';
import { resolveFormInputValue, type FormInputValues } from '@src/domains/orders/core/form-inputs/formInputGroupState';
import type { FormInputValue } from '@src/domains/orders/core/form-inputs/types';

export const buildFormInputPayload = (
  formInputGroups: Array<SaleFormInput[]>,
  values: FormInputValues,
): FormInputValue[] =>
  formInputGroups.flat().reduce<FormInputValue[]>((acc, input) => {
    const normalized = normalizeFormInputValue(
      { hash: input.hash, value: resolveFormInputValue(input, values), inputType: input.inputType },
      input.validationRules,
    );

    // Checked after normalizing: a CPF typed as punctuation alone becomes empty there.
    if (normalized.value.trim() === '') {
      return acc;
    }

    return [...acc, normalized];
  }, []);
